import { keyBy } from 'lodash';
import * as actionTypes from './actionTypes';

export function fetchGroups(payload) {
  return { type: actionTypes.FETCH_GROUPS_COLLECTION, payload };
}

export function fetchGroupsSuccess(groups, params) {
  // console.log('groups...', groups)
  const byId = keyBy(groups, (group) => group.groupUid);
  return { type: actionTypes.FETCH_GROUPS_COLLECTION_SUCCESS, payload: { byId, params } };
}